import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import firebase from 'firebase';
//import { ConnectedRouter } from 'react-router-redux';
//import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
//import registerServiceWorker from './registerServiceWorker';
import {registerServiceWorker} from './servicesworker';
// Create browser history to use in the Redux store
//const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
//const history = createBrowserHistory({ basename: baseUrl });

// Get the application-wide store instance, prepopulating with state from the server where available.
const initialState = window.initialReduxState;
const store = configureStore(initialState);

  const firebaseConfig = {
    apiKey: "AIzaSyCwt7Is0qx-vWhoZj_wjBgSbfeHFu2l7Cs",
    authDomain: "backoffice-app-7b2c5.firebaseapp.com",
    databaseURL: "https://backoffice-app-7b2c5.firebaseio.com",
    projectId: "backoffice-app-7b2c5",
    storageBucket: "backoffice-app-7b2c5.appspot.com",
    messagingSenderId: "248604321200",
    appId: "1:248604321200:web:77477859e79d1c67796275"
  };
  if (firebase.messaging.isSupported()) {
    firebase.initializeApp(firebaseConfig);
    const messaging = firebase.messaging();
  messaging.requestPermission().then(function() {
     
      return messaging.getToken();
    }).then(function(token) {
     
    }).catch(function(err) {
      console.log('Unable to get permission to notify.', err);
    });
  } else {
    console.log('no-support :(')
  }
  
const rootElement = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    
      <App />
   
  </Provider>,
  rootElement);

registerServiceWorker()
